import { Box, Typography } from "@mui/material";
import { useEffect } from "react";
import Splitting from "splitting";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const Section1 = () => {
	useEffect(() => {
		const tl = gsap.timeline();
		tl.to(".div1", { opacity: 1, delay: 2 })
		const target = document.querySelectorAll("#target");
		Splitting({ target: target, by: 'chars' });
		const charForSplit = document.querySelectorAll(".char");
		tl.from(charForSplit, { duration: 1, opacity: 0, stagger: 0.06, ease: "back.out" });
		const desc = document.querySelectorAll(".desc");
		tl.to(desc, { opacity: 1 });
	}, [])
	return (
		<Box className="div1" sx={{ opacity: 0, position: "relative", px: 10, display: "flex", flexDirection: "column", justifyContent: "center", height: "100vh" }}>
			<Typography component="h2"
				id="target"
				sx={{ fontSize: "5rem", fontWeight: 700, maxWidth: 700, lineHeight: 1.3, }}
				className="title">
				<p className="stroke">DRONE </p>
				SERVICE</Typography>
			<Typography sx={{ mt: 4, opacity: 0, fontSize: "1.2rem", maxWidth: 700 }} className="desc" component="p">Drone Destination, together with its sister company, Hubblefly Technologies, a DGCA-approved manufacturer, is a DGCA-authorized Remote Pilot Training Organization that has developed an integrated drone eco-system built around drone manufacturing, certified training, services, and rent a drone.</Typography>

		</Box>
	)
}

export default Section1;